import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { motion, AnimatePresence } from 'framer-motion';

export const AppShell = () => {
  const loc = useLocation();
  return (
    <div className="App min-h-dvh">
      <main className="flex-1 max-w-[640px] w-full mx-auto px-4 pt-4 pb-2">
        <AnimatePresence mode="wait">
          <motion.div
            key={loc.pathname}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            transition={{ duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
        <div className="nav-spacer" />
      </main>
      <BottomNav />
    </div>
  );
};
